import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import GlobalStyles from "../../assets/js/globalStyles";
import { httpGetAllNotificationByNotificationType } from "../../service/httpClient";
import * as Constants from "../../constants/Constants";
import { AgGridReact } from "ag-grid-react";
import AgGridDownloadRenderer from "../Common/AgGridDownloadRenderer/AgGridDownloadRenderer";
import "./Notifications.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allNotificationList: [],
      columnDefs: [
        {
          headerName: "Date",
          field: "createdDate",
          filter: true,
          width: 150,
          sort: { direction: "desc", priority: 0 },
          sortable: true,
          suppressMovable: true,
          cellStyle: { "white-space": "normal" },
          resizable: true,
        },
        {
          headerName: "Notification",
          field: "notificationMessage",
          filter: true,
          width: 700,
          autoHeight: true,
          sortable: true,
          suppressMovable: true,
          cellStyle: { "white-space": "normal" },
          resizable: true,
        },
        {
          headerName: "Attachment",
          field: "documentUrl",
          width: 300,
          autoHeight: true,
          cellRendererFramework: AgGridDownloadRenderer,
          colId: "attachmentPath",
          lockVisible: true,
          suppressMovable: true,
          cellStyle: { "white-space": "normal" },
          resizable: true,
        },
      ],
      paginationPageSize: 10,
      context: { componentParent: this },
      overlayNoRowsTemplate: "No Notification available",
    };
  }

  componentDidMount() {
    this.getAllNotificationListByType(Constants.NOTIFICATION_TYPE.NOTIFICATION);
  }

  getAllNotificationListByType = (notificationType) => {
    httpGetAllNotificationByNotificationType(notificationType)
      .then((response) => {
        if (response && response.data) {
          this.setState({
            allNotificationList: response.data,
          });
        }
      })
      .catch((err) => {
        console.log("error message in allNotificationList : ", err);
        this.setState({ allNotificationList: [] });
      });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  };

  autoSizeColumns = (params) => {
    const colIds = params.columnApi
      .getAllDisplayedColumns()
      .map((col) => col.getColId());
    params.columnApi.autoSizeColumns(colIds);
  };

  onColumnResized() {
    this.gridApi.resetRowHeights();
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <div className="notifications">
          <div className="notifications-title">{Constants.NOTIFICATIONS}</div>
          <div className="ag-theme-balham notifications-table">
            <AgGridReact
              columnDefs={this.state.columnDefs}
              rowData={this.state.allNotificationList}
              rowSelection="multiple"
              pagination={true}
              paginationPageSize={this.state.paginationPageSize}
              onGridReady={this.onGridReady}
              context={this.state.context}
              className={classes.agPagingPanel}
              onColumnResized={this.onColumnResized.bind(this)}
              overlayNoRowsTemplate={this.state.overlayNoRowsTemplate}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(GlobalStyles)(Notifications);
